import { AppState } from '../../types';
import {
  StateListScenes, StateFormScenes, AutoSaveState,
} from './types';

export const selectListScenes = (state: AppState): StateListScenes => state.scenes.list;

export const selectFormScenes = (state: AppState): StateFormScenes => state.scenes.form;

export const selectCurrentSceneId = (state: AppState): number => state.scenes.currentSceneId;

export const selectAutoSave = (state: AppState): AutoSaveState => state.scenes.autoSave;
